// 蝴蝶柱形图
import ChartTemplate from '../ChartTemplate';

export default {
  extends: ChartTemplate,
  methods: {
    initOptionAfter () {
      let option = {
        chart: { inverted: true },
        plotOptions: {
          column: { stacking: 'normal' },
          series: { dataLabels: { pointFormatter: function () { return Math.abs(this.y) } } }
        },
        tooltip: { headerFormat: '', pointFormatter: function () { return `${this.name}: ${Math.abs(this.y)}` } },
        yAxis: { labels: { formatter: function () { return Math.abs(this.value) } } },
      }
      this.Utility.deepMerge(this.chartOption, option);
    }
  }
}